angular.module('impactx.validationbutton').controller('ValidationButtonCtrl', [
    '$scope',
    'TranslationService',
    'ValidationTooltip',
    '$timeout',
    ValidationButtonCtrl
]);

/**
 * Adds error text to the error structure for the given property name.
 *
 * @param scopeObj scope object
 * @param errorListName name of the list in the scope object
 * @param propertyName name of the property
 * @param errorText error text
 */
ValidationButtonCtrl.prototype.addPropertyError = function (scopeObj, errorListName, propertyName, errorText, elementId) {
    var found = false, idx;

    if (!scopeObj || !errorListName) {
        return;
    }

    if (!scopeObj[errorListName]) {
        scopeObj[errorListName] = [];
    }

    for (idx = 0; idx < scopeObj[errorListName].length; idx++) {
        if (scopeObj[errorListName][idx].type == propertyName) {
            found = true;
            break;
        }
    }

    if (!found) {
        scopeObj[errorListName].push({
            type: propertyName,
            title: propertyName + '(s) ???',
            titleKey: "",
            fields: [],
            fieldCounter: []
        });
        idx = scopeObj[errorListName].length - 1;
    }

    var errorList = scopeObj[errorListName][idx];
    var index = errorList.fields.indexOf({label: errorText, key: elementId});
    if (errorText.length > 0) {
        if (index < 0) {
            errorList.fields.push({label: errorText, key: elementId});
            errorList.fieldCounter[errorList.fields.indexOf({label: errorText, key: elementId})] = 1;
        }
        else {
            errorList.fieldCounter[index]++;
        }
    }
};

/**
 * Adjust the title-keys for the given scope object and its error list.
 *
 * @param scopeObj scope object
 * @param errorListName name of the list in the scope object
 * @param translationMap simple object which stores title keys, which are used for translation
 * @param defaultManyKey (optional) default title key for many errors
 * @param defaultSingleKey (optional) default title key for single error
 */
ValidationButtonCtrl.prototype.adjustListTitleKeys = function (scopeObj, errorListName, translationMap, defaultManyKey, defaultSingleKey) {
    var idx, currentTypeToCheck, assigned, numErrors;

    if (!scopeObj || !errorListName || !scopeObj[errorListName] || (scopeObj[errorListName].length === 0)) {
        //Empty arrays are also false, but check length anyway.
        return;
    }

    for (idx = 0; idx < scopeObj[errorListName].length; idx++) {
        currentTypeToCheck = scopeObj[errorListName][idx].type;
        numErrors = 0;
        assigned = false;

        if (scopeObj[errorListName][idx].fields) {
            numErrors = scopeObj[errorListName][idx].fields.length;
        }

        if (currentTypeToCheck) {
            if (translationMap && translationMap[currentTypeToCheck]) {
                if (numErrors > 0) {
                    if (numErrors === 1 && translationMap[currentTypeToCheck].single) {
                        scopeObj[errorListName][idx].titleKey = translationMap[currentTypeToCheck].single;
                        assigned = true;
                    }
                    else if (translationMap[currentTypeToCheck].many) {
                        scopeObj[errorListName][idx].titleKey = translationMap[currentTypeToCheck].many;
                        assigned = true;
                    }
                }
            }
        }

        //Fallback to defaults
        if (!assigned) {
            if (numErrors === 1 && defaultSingleKey) {
                scopeObj[errorListName][idx].titleKey = defaultSingleKey;
            }
            else {
                scopeObj[errorListName][idx].titleKey = defaultManyKey;
            }
        }
    }
};

/**
 * Checks whether there is a translation for the given property name.
 *
 * @param propertyName property name/type
 * @param translationMap translation map for keys
 * @param translationService translation service to use
 * @return {boolean} true when there is a translation present, false otherwise.
 */
ValidationButtonCtrl.prototype.hasTranslation = function (propertyName, translationMap, translationService) {
    var translation;
    if (propertyName && translationService && (typeof translationService.get === 'function')) {
        if (translationMap && translationMap[propertyName]) {
            //At least for many 'errors' translation should be there
            if (translationMap[propertyName].many) {
                translation = translationService.get(translationMap[propertyName].many);
            }
            if (translation) {
                return true;
            }
        }
    }

    return false;
};

function ValidationButtonCtrl($scope, TranslationService, ValidationTooltip, $timeout) {
    var self = this;
    $scope.direction = 'bottom';
    $scope.pending = false;

    self.handleAction = function (event) {
        if ($scope.pending || self.isInvalid()) return;
        var result = $scope.action({ event: event });
        if (result && typeof result.then === 'function') {
            $scope.pending = true;
            result.then(function () {
                $scope.pending = false;
            }, function () {
                $scope.pending = false;
            });
        }
    };
    /*
     * List of errors
     */
    $scope.errorFields = [];
    /*
     * List of counters for separate error fields.
     */
    $scope.errorFieldCounter = [];
    //Configure titles for error lists

    //See UXTranslation.java for names
    //We use here a mapping to give more flexibility in naming translation keys in backend.
    $scope.translationMap = {
        email: {
            single: 'invalidEmailField',
            many: 'invalidEmailFields'
        },
        date: {
            single: 'error_date',
            many: 'errors_date'
        },
        maxlength: {
            single: 'error_maxlength',
            many: 'errors_maxlength',
            limit: 'error_maxlength_limit'
        },
        minlength: {
            single: 'error_minlength',
            many: 'errors_minlength',
            limit: 'error_minlength_limit'
        },
        url: {
            single: "invalidUrlField",
            many: "invalidUrlFields"
        }
    };

    self.open = function (event, errorData) {
        ValidationTooltip.open(event, errorData, $scope.tooltipDirectionTop);
    }

    /**
     * Adds error message for given input.
     * @param propertyName name/type of the property which failed the test
     * @param errorText error text
     * @param inputObj input object
     * @param errorParams (optional) additional parameters
     */
    $scope.addErrorFromInputExt = function (propertyName, errorText, inputObj, errorParams) {
        var realErrorText = errorText, paramsTemplate, paramsText = '';

        if (inputObj && (typeof inputObj.attr == 'function') && inputObj.attr('header')) {
            realErrorText += ' ( ' + inputObj.attr('header') + ' )';
        }
        if (errorParams) {
            if (errorParams.limit) {
                //Defined
                if ($scope.translationMap && $scope.translationMap[propertyName] && $scope.translationMap[propertyName].limit) {
                    paramsTemplate = TranslationService.get($scope.translationMap[propertyName].limit);
                }
                //try given alternative template!
                if (!paramsTemplate && errorParams.limitAlternative) {
                    paramsTemplate = errorParams.limitAlternative;
                }

                if (!paramsTemplate) {
                    paramsTemplate = ' (limit: ^0)';
                }

                paramsText = ' ' + paramsTemplate.replace('^0', errorParams.limit);
            }
        }

        realErrorText += paramsText;

        if (self.hasTranslation(propertyName, $scope.translationMap, TranslationService)) {
            self.addPropertyError($scope, 'myErrorLists', propertyName, realErrorText, inputObj.attr('id'));
        }
        else {
            //No translations defined, use our own (general) default
            self.addPropertyError($scope, 'myErrorLists', "ix_invalid", realErrorText, inputObj.attr('id'));
        }

        //A bit of overhead to iterate over and over, but helps keep lists consistent.
        self.adjustListTitleKeys($scope, 'myErrorLists', $scope.translationMap, "invalidFields");
    };

    this.handleKey = function (key, property) {
        //dirty, but easy way to check if this is a nested form.
        if (key.$$controls) {
            self.handleNestedForm(key, property);
        }
        else {
            self.handleField(key, property);
        }
    };

    self.handleNestedForm = function (key, property) {
        angular.forEach(key.$error[property], function (key) {
            self.handleKey(key, property);
        });
    };

    self.handleField = function (key, property) {
        var id, input, label, text, index;
        if (key.$invalid) {
            // input
            input = $("input[name='" + key.$name + "']");

            // md-select
            if (input.length === 0) {
                input = $("md-select[name='" + key.$name + "']");
            }

            // md-datepicker
            if (input.length === 0) {
                input = $("md-datepicker[name='" + key.$name + "']");
            }

            // textarea
            if (input.length === 0) {
                input = $("textarea[name='" + key.$name + "']");
            }

            // ix-checkbox-group
            if (input.length === 0) {
                input = $("ix-checkbox-group[name='" + key.$name + "']");
            }

            id = input.attr('id');

            // check if there is a label with class "validation-label" for the input first, that class marks the label
            // dedicated for the validation messages. The reason being that angular seems to insert the for-attribute
            // if it is missing (setting the id of the first input found after the label)
            label = $("label[for='" + id + "'].validation-label");
            if (label.length === 0) {
                // if there is no dedicated label go with any label for the input
                label = $("label[for='" + id + "']");
            }
            //var length = input.length;
            // autocomplete (.prev() is pretty ugly but the only way to get the label)
            if (label.length === 0) {
                if (input[0] && input[0].hasAttribute("ui-tinymce")) {
                    //special case for tinymce, because we don't control the dom here.
                    label = input.parent().prev();
                }
                else {
                    label = input.prev();
                }
            }

            // if there is more than one, only take the first
            if (label.length > 1) {
                label = label.first();
            }
            text = label.text().trim();
            // app control chip: uses placeholder instead of label
            if (text.length === 0) {
                var placeholder = input.attr('placeholder');
                if (placeholder) {
                    text = placeholder.trim();
                }
            }

            // ix-checkbox-group: uses data-label attribute
            if (text.length === 0) {
                var dataLabel = input.attr('data-label');
                if (dataLabel) {
                    text = dataLabel.trim();
                }
            }

            var errorItem = {key: key.$name, label: text};
            index = $scope.errorFields.indexOf(text);

            if (property === 'required' || property === 'attachmentRequired') {
                if (text.length > 0) {
                    if (index < 0) {
                        $scope.errorFields.push(errorItem);
                        $scope.errorFieldCounter[$scope.errorFields.indexOf(errorItem)] = 1;
                    }
                    else {
                        $scope.errorFieldCounter[index]++;
                    }
                }
            }
            else {
                switch (property) {
                    case 'email':
                        $scope.addErrorFromInputExt(property, text, input);
                        break;
                    case 'maxlength':
                        $scope.addErrorFromInputExt(property, text, input, {
                            limit: input.attr('ng-maxlength'),
                            limitAlternative: '(max ^0)'
                        });
                        break;
                    case 'minlength':
                        $scope.addErrorFromInputExt(property, text, input, {
                            limit: input.attr('ng-minlength'),
                            limitAlternative: '(min ^0)'
                        });
                        break;
                    //Add here for other specific input types ... (Remember: 'break;')
                    default:
                        //Define in translationMap your mappings, for error messages with parameters
                        //transfer parameters as last parameter object.
                        $scope.addErrorFromInputExt(property, text, input);
                        break;
                }
            }
        }
    };

    self.isInvalid = function () {
        if ($scope.disableExpression) {
            if ($scope.form) {
                return checkForm() || $scope.disableExpression.value || ($scope.disableExpression.valueFunction && $scope.disableExpression.valueFunction());
            }
        }
        if ($scope.disableExpressions) {
            if ($scope.form) {
                return checkForm() || $scope.disableExpressions.value || ($scope.disableExpressions.valueFunction && $scope.disableExpressions.valueFunction());
            }
        }
        else {
            if ($scope.form) {
                return checkForm();
            }
        }
    };

    function checkForm() {
        if ($scope.ignoreFields) {
            var isValid = true;
            angular.forEach($scope.form.$getControls(), function (field) {
                if ($scope.ignoreFields.indexOf(field.$name) < 0) {
                    isValid = isValid && field.$valid;
                }
            });
            return !isValid;
        }
        return $scope.disabled || $scope.form.$invalid;
    }

    self.hide = ValidationTooltip.hide;
    self.cancelPromise = ValidationTooltip.cancelPromise;

    

    self.checkValidity = function (event) {
        self.cancelPromise();
        var property;
        $scope.errorFields = [];
        $scope.myErrorLists = [];
        var fromAngular = false;

        if(!$scope.form) {
            return;
        }

        if($scope.form.$error && $scope.form.$error.isAngular) {
            fromAngular = self.handleAngularErrors($scope.form);
        } else {
            for (property in $scope.form.$error) {
                if ($scope.form.$error.hasOwnProperty(property)) {
                    angular.forEach($scope.form.$error[property], function (key) {
                        if (!$scope.ignoreFields || $scope.ignoreFields.indexOf(key.$name) < 0) {
                            self.handleKey(key, property);
                        }
                    });
                }
            }

            // Deduplicate fields within each error list (e.g. a checkbox-group may
            // trigger multiple validity keys that all map to the same label+key pair)
            angular.forEach($scope.myErrorLists, function (errorList) {
                var seen = {};
                errorList.fields = errorList.fields.filter(function (field) {
                    var id = field.label + '||' + field.key;
                    if (seen[id]) { return false; }
                    seen[id] = true;
                    return true;
                });
            });
        }

        var errorData = {
            fromAngular: fromAngular,
            errorFields: $scope.errorFields,
            errorFieldCounter: $scope.errorFieldCounter,
            myErrorLists: $scope.myErrorLists,
            disableExpressions: $scope.disableExpressions,
            disableExpression: $scope.disableExpression,
        };
        if (hasErrors()) {
            self.open(event, errorData);
        }
    };

    function hasErrors() {
        var errorFound = false;
        for (var i = 0; i < $scope.myErrorLists.length; i++) {
            var myErrorList = $scope.myErrorLists[i];
            if (myErrorList.fields && myErrorList.fields.length > 0) {
                errorFound = true;
                break;
            }
        }
        // $scope.disableExpressions is not an array!
        var hasDisableExpressions = false;
        if ($scope.disableExpressions) {
            hasDisableExpressions = $scope.disableExpressions.value || ($scope.disableExpressions.valueFunction && $scope.disableExpressions.valueFunction())
        }

        var hasDisableExpression = false;
        if ($scope.disableExpression) {
            hasDisableExpression = $scope.disableExpression.value || ($scope.disableExpression.valueFunction && $scope.disableExpression.valueFunction());
        }

        return $scope.errorFields.length > 0 || hasDisableExpressions || hasDisableExpression || errorFound;
    }

    function handleSingleAngularError(errorMap, errorObj) {
        var errorType;
        if(impactX.isJsObject(errorMap) && 
            impactX.isJsObject(errorObj) && 
            impactX.isJsObject(errorObj.$error)) {

            for(errorType in errorObj.$error) {
                
                if(!errorObj.$error[errorType] 
                    || errorType === '$invalid'
                    || errorType === '$valid'
                ) {
                    continue; // No error!
                }

                if(!impactX.isJsObject(errorMap[errorType])) {
                    errorMap[errorType] = {
                        key: [errorType],
                        titleKey: errorType, // Translation somewhere else to do
                        fields:[],
                        fieldCounter:[]
                    };
                }
                let text = errorObj.$name;
        
                if(errorObj.label) {
                    text = errorObj.label;
                } else if (errorObj.placeholder){
                    text = errorObj.placeholder;
                }

                if(typeof text !== 'string' || !text) {
                    // to prevent unreadable outputs for non-strings
                    text = '???'; 
                }
        
                errorMap[errorType].fields.push({
                    label: text,
                    type: errorType,
                    errorObj: errorObj
                });
            }
        }
    };

    /**
     * Tries to extract errors from an Angular component/view
     * @param {*} form 
     * @returns true, when some errors found
     */
    self.handleAngularErrors = function(form) {
        var errorObj, property, fromAngular = false;
        var errorMap ={};

        for(property in form.$error) {
            errorObj = form.$error[property];
            //console.log('Handle:', errorObj);
            if(errorObj) {
                fromAngular = true;
                handleSingleAngularError(
                    errorMap, 
                    errorObj
                );
            }
        }

        for(property in errorMap) {
            $scope.myErrorLists.push(errorMap[property]);
        }
        return fromAngular;
    }
}